import MainLayout from "../layouts/MainLayout.vue";
export default function getRoutes({ Vue, store }) {
  const authenticateUser = (to, from, next) => {
    try {
      const blnIsUserLoggedIn = store.getters["blnIsUserLoggedIn"];
      console.log(blnIsUserLoggedIn);
      if (!blnIsUserLoggedIn) {
        console.log("redirecting", to);
        location.href = "/login?to=" + to.fullPath;
        return;
        // return next({
        //   name: "SignIn",
        //   params: { strTarget: to.fullPath },
        // });
      }
    } catch (e) {
      console.log(e);
      location.href = "/login?to=" + to.fullPath;
      return;
      // return next({
      //   name: "SignIn",
      // });
    }
    next();
  };

  const routes = [
    {
      path: "/",
      name: "",
      component: MainLayout,
      children: [
        {
          path: "/u",
          component: () =>
            import(/* webpackChunkName: "home" */ "../layouts/UserLayout.vue"),
          beforeEnter: authenticateUser,
          children: [],
        },
        {
          path: "",
          name: "Home",
          props: true,
          component: () =>
            import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
        },

        {
          path: "cart",
          name: "Cart",
          component: () =>
            import(/* webpackChunkName: "cart" */ "../views/Cart.vue"),
        },

        {
          path: "ticketprint",
          name: "Ticket",
          component: () =>
            import(/* webpackChunkName: "cart" */ "../views/TicketPrint.vue"),
        },

        {
          path: "all-results",
          name: "AllResults",
          props: true,
          component: () =>
            import(/* webpackChunkName: "results" */ "../views/AllResults.vue"),
        },

        {
          path: "redirector",
          name: "Redirector",
          props: true,
          component: () =>
            import(/* webpackChunkName: "home" */ "../views/Redirector.vue"),
        },

        {
          path: "pick",
          name: "PickNumbers",
          props: true,
          component: () =>
            import(/* webpackChunkName: "picker" */ "../views/PickNumbers.vue"),
        },
        {
          path: "order-confirmation",
          name: "OrderConfirmation",
          component: () =>
            import(
              /* webpackChunkName: "cart" */ "../views/OrderConfirmation.vue"
            ),
        },
      ],
    },
  ];

  return routes;
}
